export const Loaders = {
  Report: {
    ReportUpload: 'report-upload',
  },
};
